// removed by extract-text-webpack-plugin
module.exports = {"slider":"_2ZqBFwjako55baqvkntM4J","optionsSection":"_1wvbhAmnrNgwWjjnEZFhPP","mainForm":"TWEy7J_2kky5pjjhr_UFG","uploadForm":"_3dU0kPrDoCbhHA6f7YiuBx","filesManagement":"_3_MZdDa1RomBk3JU7MV0P0","optionsForm":"_2Mp5dL7XZzY2MRVOh-LeHs","backButton":"_3kjSUwu1Q3aZJAFml3xYA","step2":"_3M8pMXNwdoWKgYO06MV1tG","step1":"pOdfZh9uhIo3g0UhzXIAe","mainSection":"_3cHO0S0EpdBxrMj9DPs8My","visible":"_2step3ZHlGDQc2Tnum2TPd","recipients":"q-wFa8vEKNICbOJRdpLnI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/QuickSendForm.scss
// module id = 1302
// module chunks = 1